import md5 from 'md5';

export function useClientToken() {
  const config = useRuntimeConfig();
  const partssalt = config.public.partssalt;

  const now = new Date(Date.now());
  const utcMonth = String(now.getUTCMonth() + 1).padStart(2, '0');
  const utcDay = String(now.getUTCDate()).padStart(2, '0');
  const utcHour = String(now.getUTCHours()).padStart(2, '0');

  const hashString = `${utcMonth}${partssalt}${utcDay}${utcHour}`;
  return md5(hashString);
}